import { useState, useEffect } from "react";
import {
  Title,
  SubTitle,
  Container,
  DivIcon,
  TableContainer,
  Table,
  StatusFormat,
  THSel,
  THACC,
  THLabel,
  THStatus,
  TDSel,
  TDACC,
  TDLabel,
  TDStatus,
  TRLine,
  Footer,
  ButtonSpace,
} from "./styles";
import Accountable from "../../Accountable/index";
import Close from "../../../../assets/icons/Close";
import Modal from "../../Modal";
import { useDispatch, useSelector } from "react-redux";
import { handleListTaskAccountable } from "../../../../state/users/actions";
import { handleUpdateMultipleACC } from "../../../../state/activedFlows/actions";
import { toastAlert } from "../../../Toastify/index";
import { useGantt } from "../../../../hooks/useGantt";

import Checkbox from "../../Checkbox/index";
import {
  handleUpdateAccountableTask,
  handleRemoveAccountableTask,
} from "../../../../state/activedFlows/actions";

import Button from "../../Button/index";
import { Collapse } from "react-collapse";
import AccountableWithConfirm from "../../AccountableWithConfirm/index";

const ConfirmACC = ({ onCancel, onConfirm, isDisable }) => (
  <ButtonSpace>
    <Button
      content={<span style={{ fontSize: "13.5px" }}>Cancelar</span>}
      outline
      width={"7.95rem"}
      onClick={onCancel}
    />
    <Button
      greenBase
      disabled={isDisable}
      content={<span style={{ fontSize: "13.5px" }}>Atribuir Tarefas</span>}
      width={"11.75rem"}
      onClick={onConfirm}
    />
  </ButtonSpace>
);

const getAvTasks = (elements, jobs) => {
  const tasks = elements.filter(
    (el) => el.type === "task" && el.data.status !== "done",
  );

  const avTasks = tasks.filter((task) => jobs.some((j) => j.id === task.id));

  return avTasks.map((task) => {
    const job = jobs.find((j) => j.id === task.id);
    return { ...task, jobStatus: job.status };
  });
};

const getStatus = (task) => {
  const status = task.jobStatus;

  return status === "doing"
    ? "Em execução"
    : status === "pending"
      ? "Pendente"
      : status === "done"
        ? "Concluído"
        : "Atrasado";
};
const DelegateAllModal = ({
  isOpen,
  onClose,
  onConfirm,
  selector,
  className,
}) => {
  const [accList, setACCList] = useState([]);
  const [accUser, setACCUser] = useState(null);
  const [openSearch, setOpenSearch] = useState(false);

  const { jobs } = useGantt();
  const elements = useSelector(
    (state) => state.activedFlows.pane.flow.elements,
  );

  const handles = {
    updateAcc: handleUpdateAccountableTask,
    removeAcc: handleRemoveAccountableTask,
  };

  const dispatch = useDispatch();

  async function fetchAccountables() {
    try {
      const res = await dispatch(handleListTaskAccountable());
      setACCList(res.data.usersByTenant);
    } catch (err) {
      toastAlert({
        msg: `Ocorreu um erro ao buscar usuários disponiveis: ${err}`,
        isError: true,
      });
    }
  }

  useEffect(() => {
    let isMounted = true;

    if (isMounted) fetchAccountables();

    return () => (isMounted = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const avTasks = getAvTasks(elements, jobs);

  const [list, setList] = useState(
    avTasks.map((item) => (item = { ...item, checked: false })),
  );

  const checkItem = (task) =>
    setList(
      list.map((item) =>
        item._id === task._id
          ? (item = { ...item, checked: !item.checked })
          : item,
      ),
    );

  const onCancel = () => {
    setACCUser(null);
    unCheckAll();
  };
  const checkedNumbers = list.filter((item) => item.checked === true).length;
  const isAllChecked = checkedNumbers === list.length;

  const updateMultipleACC = async () => {
    const tasksList = list
      .filter((item) => item.checked)
      .map((item) => (item = { taskId: item._id }));

    await dispatch(handleUpdateMultipleACC({ tasksList, userId: accUser._id }))
      .then((res) => {
        updateStateMultiple(res.payload);
        toastAlert({ msg: "Tarefas Delegadas com  SUCESSO!" });
        //onClose();
      })
      .catch((err) =>
        toastAlert({
          msg: `Ocorreu um ERRO ao delegar as tarefas: ${err}`,
        }),
      );
  };

  const checkAll = () => {
    setList(list.map((item) => (item = { ...item, checked: true })));
  };

  const unCheckAll = () => {
    setList(list.map((item) => (item = { ...item, checked: false })));
  };
  const updateState = (payload) => {
    const taskId = payload.taskId;
    const accountable = payload.accountable;

    setList(
      list.map((item) =>
        item._id === taskId
          ? (item = {
              ...item,
              data: { ...item.data, accountable: accountable },
            })
          : item,
      ),
    );
  };

  const updateStateMultiple = (payload) => {
    const accountable = payload.accountable;

    setList(
      list.map((item) => {
        const task = payload.list.find((n) => n.taskId === item._id);

        if (task) {
          return {
            ...item,
            data: { ...item.data, accountable },
            checked: false,
          };
        }

        return { ...item, checked: false };
      }),
    );
    setACCUser(null);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Title>Gerenciamento de Tarefas</Title>
        <SubTitle>Delegue tarefas para outros usuários</SubTitle>

        <Collapse isOpened={checkedNumbers > 0}>
          <hr style={{ width: "90%", margin: "0.6rem 0 0.6rem 0" }} />
          <div style={{ background: "#cff8e7", width: "90%" }}>
            <AccountableWithConfirm
              subtitle="Responsável pelas tarefas selecionadas"
              user={[accUser, setACCUser]}
              open={[openSearch, setOpenSearch]}
              list={accList}
            />
          </div>
        </Collapse>

        <hr style={{ width: "90%", margin: "0.6rem 0 0.6rem 0" }} />
        <div style={{ display: "flex" }}>
          <span style={{ margin: "1rem 1rem 1rem 0" }}>
            Tarefas disponíveis
          </span>

          <Checkbox
            checked={isAllChecked}
            onChange={() => {
              if (isAllChecked) {
                unCheckAll();
              } else {
                checkAll();
              }
            }}
            label={!isAllChecked ? "Marcar Todas" : "Desmarcar Todas"}
          />
        </div>
        <TableContainer>
          <Table>
            <thead className="table-head">
              <tr className="first-line">
                <THSel>Sel</THSel>
                <THLabel>Nome</THLabel>
                <THStatus>Status</THStatus>
                <THACC>Responsável</THACC>
              </tr>
            </thead>
            <tbody>
              {list.map((item, i) => (
                <TRLine checked={item.checked} key={Math.random()}>
                  <TDSel>
                    <Checkbox
                      checked={item.checked}
                      onChange={() => checkItem(item)}
                    />
                  </TDSel>
                  <TDLabel>{item.data.label}</TDLabel>
                  <TDStatus>
                    <StatusFormat status={item.jobStatus}>
                      {getStatus(item)}
                    </StatusFormat>
                  </TDStatus>
                  <TDACC>
                    <Accountable
                      style={{
                        height: "2rem",
                        width: "100%",
                      }}
                      subtitle=""
                      accountable={item.data.accountable}
                      list={accList}
                      id={item._id}
                      handles={handles}
                      callback={updateState}
                    />
                  </TDACC>
                </TRLine>
              ))}
            </tbody>
          </Table>
        </TableContainer>
        {checkedNumbers > 0 ? (
          <Footer>
            <span>
              {checkedNumbers}
              {checkedNumbers > 1
                ? " Tarefas Selecionadas"
                : " Tarefa Selecionada"}
            </span>
            <div>
              <ConfirmACC
                onCancel={onCancel}
                onConfirm={updateMultipleACC}
                isDisable={!accUser}
              />
            </div>
          </Footer>
        ) : null}

        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default DelegateAllModal;
